import './scss/index.scss';

import {skalert} from './alert';
import {loading, SkLoading} from './loading';
import {Checkbox, Desc, Field, File, updateDirty, Line, List, Policy, Select, Text, DateTime, Radio, CheckboxSelect, Cascader} from './field';
import {sktips} from './tips';
import {ck, cr, interact} from 'fire-wind-water';
import {config} from './conf/settings';
import {sxhr, sxhrRequest, sxhrHeaders} from 'fire-wind-water/sxhr';
import {JsonObject} from './interface/json';
import {$get, $httpGet, $skxhr, $skxhrp, $upload} from './services';

export const setApiUrl = cr.noop;
export const setUploadUrl = cr.noop;

ck.json = true;
sxhrRequest(<T>(config: JsonObject): T => {
  if (config.method === 'post' || config.method === 'POST') {
    cr.extend(true, config.data, {browseInfo: interact.browseInfo, globalUserId: ck.cookie('globalUserId')});
  }
  if(config.url.includes('/member/login') || config.url.includes('/member/register')){
    let m = ck.cookie('miniMipToken');
    if(m){
      m = m.replace('bearer ', '');
      cr.extend(true, config.data, {miniMipToken: m || null});
    }
  }

  return config as T;
}, () => {
});
sxhrHeaders('Content-Type', 'text/plain');

const $sk: any = {
  alert(html: string, conf: { [label: string]: any }): void {
    skalert.show(html, conf, 0);
  },
  confirm(html: string, conf: { [label: string]: any }): void {
    skalert.show(html, conf, 1);
  },
  loading: loading,
  inlineLoading(){
    return new SkLoading();
  },
  tips: sktips,
  Checkbox, Desc, Field, File, updateDirty, Line, List, Policy, Select, Text, DateTime, Radio, CheckboxSelect, Cascader,
  setApiUrl, setUploadUrl,
  sxhrRequest, sxhrHeaders,
  sxhr
};

$sk.$skxhr = $skxhr;
$sk.$skxhrp = $skxhrp;
$sk.$upload = $upload;
$sk.$xhrget = $httpGet;
$sk.$xhrgetp = $get;
$sk.config = config;
export {
  $sk
};
